import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/caspianentertain/amburan.caspianentertainment.com/components/Lang/Lang.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/caspianentertain/amburan.caspianentertainment.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/arrowBack.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/bong.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/builder.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/kids_club.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/logo.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/motor.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/icon/sweet.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/images/blueStar.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/images/girlRocket.svg");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/images/star1.png");
;
import(/* webpackMode: "eager" */ "/home/caspianentertain/amburan.caspianentertainment.com/public/images/star2.png");
